module.exports = __webpack_public_path__ + "assets/images/sport24_tv.602510e8113e727686e9b8036b78b92e.png";